module.exports = __webpack_public_path__ + "img/imgPerfil.acbc1235.png";